import { FILTER_ORDER_STATUSES, type OrderStatus } from '@/lib/vision/schemas'
import { STATUS_LABEL } from '@/components/status-pill'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuFilterHeader,
  DropdownMenuFilterTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { Badge } from '@/components/ui/badge'

const ALL_STATUSES = FILTER_ORDER_STATUSES

export function StatusFilter({
  value,
  onChange,
}: {
  value: OrderStatus[]
  onChange: (next: OrderStatus[]) => void
}) {
  const toggle = (status: OrderStatus) => {
    if (value.includes(status)) {
      onChange(value.filter(entry => entry !== status))
    } else {
      onChange([...value, status])
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuFilterTrigger label="Status" aria-label="Filter orders by status">
        {value.length > 0 ? (
          <Badge tone="info" className="mr-1.5 tabular-nums">
            {value.length}
          </Badge>
        ) : (
          <span className="mr-1.5 text-[color:var(--foreground)]">Any</span>
        )}
      </DropdownMenuFilterTrigger>
      <DropdownMenuContent align="start" className="min-w-52">
        <DropdownMenuFilterHeader onClear={value.length > 0 ? () => onChange([]) : undefined}>
          Filter by status
        </DropdownMenuFilterHeader>
        <DropdownMenuSeparator />
        {ALL_STATUSES.map(status => (
          <DropdownMenuCheckboxItem
            key={status}
            checked={value.includes(status)}
            onCheckedChange={() => toggle(status)}
            onSelect={event => event.preventDefault()}
          >
            {STATUS_LABEL[status]}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
